"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastTransactedAtFromPerpetualBondTradeTransaction = exports.getFilteredAccountsByNumber = exports.getFilteredAccounts = exports.getAllPerpetualProgramAccounts = void 0;
const constants_1 = require("../../constants");
const helpers_1 = require("../../helpers");
const types_1 = require("../../types");
const perpetual_1 = require("../perpetual");
const anchor_1 = require("@project-serum/anchor");
const bytes_1 = require("@project-serum/anchor/dist/cjs/utils/bytes");
const getAllPerpetualProgramAccounts = (programId, connection) => __awaiter(void 0, void 0, void 0, function* () {
    const program = yield (0, helpers_1.returnAnchorProgram)(programId, connection);
    const fraktBondsOffset = 8;
    const fraktBondsRaw = yield (0, exports.getFilteredAccounts)(program, 'fraktBond', fraktBondsOffset, [5, 6, 7, 8]);
    const fraktBonds = fraktBondsRaw.map((fraktBondRaw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(fraktBondRaw));
    const hadoMarketRegistry = (yield program.account.hadoMarketRegistry.all()).map((raw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(raw));
    const hadoMarketValidation = (yield program.account.hadoMarketValidation.all()).map((raw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(raw));
    const lenderLeaderboard = (yield program.account.lenderLeaderboard.all()).map((raw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(raw));
    const lenderWeeklyLeaderboard = (yield program.account.lenderWeeklyLeaderboard.all()).map((raw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(raw));
    const hadoMarketOffset = 32 + 8;
    const hadoMarketsRaw = yield (0, exports.getFilteredAccounts)(program, 'hadoMarket', hadoMarketOffset, [3, 4]);
    const hadoMarkets = hadoMarketsRaw.map((hadoMarketRaw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(hadoMarketRaw));
    const bondOfferOffset = 32 + 8;
    const bondOffersRaw = yield (0, exports.getFilteredAccounts)(program, 'bondOfferV2', bondOfferOffset, [5, 6, 7, 8, 9]);
    const bondOffersV2 = bondOffersRaw.map((acc) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(acc));
    const bondTradeTxnOffset = 8;
    const bondTradeTxnRawV3 = yield (0, exports.getFilteredAccounts)(program, 'bondTradeTransactionV3', bondTradeTxnOffset, [2, 3, 4, 5, 6, 7, 8, 9]);
    const bondTradeTxnRawV2 = yield (0, exports.getFilteredAccounts)(program, 'bondTradeTransactionV2', bondTradeTxnOffset, [2, 3, 4, 5, 6, 7, 8, 9]);
    const repaymentCall = (yield program.account.repaymentCall.all()).map((raw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(raw));
    const bondTradeTransactionsV3 = bondTradeTxnRawV3.map((acc) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(acc));
    const bondTradeTransactionsV2 = bondTradeTxnRawV2.map((acc) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(acc));
    return {
        bondTradeTransactionsV2,
        bondTradeTransactionsV3,
        bondOffersV2,
        fraktBonds,
        hadoMarketRegistry,
        hadoMarkets,
        hadoMarketValidation,
        lenderLeaderboard,
        lenderWeeklyLeaderboard,
        repaymentCall,
    };
});
exports.getAllPerpetualProgramAccounts = getAllPerpetualProgramAccounts;
const getFilteredAccounts = (program, accountName, offset, indexes) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield Promise.all(indexes.map((i) => program.account[accountName].all([
        {
            memcmp: {
                offset: offset,
                bytes: bytes_1.bs58.encode(Buffer.from([i])), //PerpetualActive
            },
        },
    ])))).flat();
});
exports.getFilteredAccounts = getFilteredAccounts;
const getFilteredAccountsByNumber = (program, accountName, offset, indexes) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield Promise.all(indexes.map((i) => program.account[accountName].all([
        {
            memcmp: {
                offset: offset,
                bytes: bytes_1.bs58.encode(new anchor_1.BN(i).toBuffer()), //PerpetualActive
            },
        },
    ])))).flat();
});
exports.getFilteredAccountsByNumber = getFilteredAccountsByNumber;
const getLastTransactedAtFromPerpetualBondTradeTransaction = (bond_trade_txn) => {
    if (bond_trade_txn.bondTradeTransactionState === types_1.BondTradeTransactionV2State.PerpetualActive)
        return bond_trade_txn.soldAt;
    if (bond_trade_txn.bondTradeTransactionState === types_1.BondTradeTransactionV2State.PerpetualManualTerminating ||
        (0, perpetual_1.nowInSeconds)() < bond_trade_txn.redeemedAt + constants_1.TERMINATION_PERIOD)
        return bond_trade_txn.redeemedAt;
    else
        return bond_trade_txn.redeemedAt + constants_1.TERMINATION_PERIOD;
};
exports.getLastTransactedAtFromPerpetualBondTradeTransaction = getLastTransactedAtFromPerpetualBondTradeTransaction;
